/**
 * 设置webview的属性
 * 目前适用于随管家
 */
import useragent from '@common/useragent'
import { call, uriSuiguanjia } from './bridge'

export default (options, callBack) => {
  if (useragent.isSuiguanjia) {
    const uri = uriSuiguanjia('sgj://app/webview/config', options, 'onSetWebViewAttribute')
    call(uri, 'onSetWebViewAttribute', callBack)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/setWebViewAttribute.js